import React from "react";

export default function About() {
  return (
    <section className="section about-section">
      <h1 className="section-title">About us</h1>
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Officiis
        quisquam quidem minus consectetur voluptas praesentium deserunt
        temporibus dolorum necessitatibus. Sint, magni necessitatibus enim
        dolore officia voluptatem autem eum iste ad, adipisci ipsum. Cum
        quibusdam eligendi natus perferendis rerum? Est sapiente placeat
        repellat voluptate, odio numquam tempora quae exercitationem provident
        similique!
      </p>
    </section>
  );
}
